export default {
  mainWrapper: {
    container: 'container device-full-width lg:px-0',
    backButton:
      'text-s13-m13-l15 font-sans-bold text-black underline hover:no-underline py-2 mt-20 inline-block',
    pageHeading: 'text-s20-m30 lg:text-7xl font-hairline mt-25 mb-10',
    formWrapperDiv: 'form-wrapper',
  },
  dropDown: {
    wrapper: '',
    categoryTitleWrapper: '',
    categoryTitle:
      'font-sans-light font-medium text-17 lg:text-4xl leading-19 lg:leading-23 pb-15 ',
    categoryWrapper: ' ',
    itemTitle:
      'font-HelveticaNeueLight text-grey font-normal text-16 leading-24 pr-0 sort-droptown-arrow ',
    itemUl: '',
    itemLi: 'text-16 font-BebasNeueRegular py-17',
    itemLabel: 'flex py-15 checkmark',
    itemCheckbox: 'absolute opacity-0 tags-checkbox',
    itemText: 'font-BebasNeueRegular text-16 leading-24 w-11/12 cursor-pointer',
    chipWrapper: 'mb-10 inline-block mt-10 mr-10',
    chip: 'py-5 pl-10 pr-15 font-sans-roma flex hover:opacity-75',
    chipLabel: 'pr-1 text-14 text-grey',
    chipCloseBtn:
      'w-4 h-4 bg-white rounded-2 no-underline text-center rounded-lg',
    accordion: {
      panel: 'w-full',
      panelHeader: 'w-full relative accordionHeader',
      panelDetail: 'trans-500-max-h p-0 border-0 relative bg-white',
      icon: 'mt-2 sort-droptown-arrow',
      expanded:
        'max-h-670 overflow-y-auto px-30 py-5 text-right dropdownContainer absolute sm:right-0 md:pin-r10 z-3',
      collapsed: 'max-h-0 overflow-hidden absolute',
    },
    expandedIcon: 'icon-arrow-down-light font-bold text-2xl sort-dropdown',
    collapsedIcon: 'icon-arrow-up-light font-bold text-2xl sort-dropdown',
  },
  writeReviewHeading:
    'text-36 leading-48 pb-30 text-black font-BornreadyRegular tracking-normal font-normal',
  productDetails: {
    wrapper: 'md:flex mt-20 md:mt-30 rating-desc-section md:-mx-15',
    imageWrapper: 'sm:w-full text-center md:text-left md:w-1/4 md:px-15',
    imageClass: 'mb-20',
    detailsWrapper: 'sm:w-full md:w-3/4 md:pl-15 md:px-15',
    details: 'mt-5 mb-10',
    detailsHeader:
      'text-2xl md:text-3xl lg:text-5xl text-black font-sans-light leading-25 md:leading-28 lg:leading-34',
    detailsPara: 'text-s13-m13-l15 font-sans-roma mb-10',
    reviewWrapper: 'product-review-section mb-30',
    reviewLink: 'text-grey-darkest text-sm font-sans-roma',
    ratingTotal: 'px-3 cursor-default',
    ratingAlignTop: 'rating-align',
    ratingWrapper: 'product-review-section mb-30 mt-10 md:mb-10',
    ratingLink:
      'text-grey-darkest text-sm font-sans-roma inline-block flex items-end',
  },
  sorryThanks: {
    modalWrapper: 'write-review-confirmation mx-auto',
    modalBG: 'bg-white mt-20',
    modalPosition: 'relative md:border-t md:border-grey-light',
    modalTitle: 'p-15',
    modalHeader:
      'text-36 leading-48 pb-30 text-black font-BornreadyRegular tracking-normal font-normal',
    modalClose: 'absolute right-0 headclose right-12 text-30 top-8',
    closeIcon: 'closespan',
    dialogWrapper: 'p-15',
    dialogContent:
      'leading-s19-m19-l23 mb-15 text-16 leading-24 font- HelveticaNeueRoman',
    buttonWrapper: 'pt-15',
    buttonClass: 'btn btn-solid',
  },
  reviewForm: {
    modalPositionShow: 'relative pt-20 px-30',
    modalPositionHidden: 'relative pt-20 px-30 hidden',
    ratingWrapper: 'rating-wrapper relative overflow-hidden w-full',
    floatLeft: 'float-left',
    mandateField:
      'font-sans-roma text-base md:absolute right-0 text-right block mb-20 w-auto',
    sectionHeading:
      'text-18 font-BebasNeueRegular text-black mb-30 md:leading-none',
    formSection: 'flex mb-20 w-full justify-between rating-star-wrapper',
    labelContainer:
      'sm:w-1/2 md:w-3/12 lg:w-1/2 md:pl-0 lg:pl-0 md:text-left md:px-0',
    label: 'text-16 font-HelveticaNeueLight label-name',
    ratingContainer: 'sm:w-1/2 md:w-8/12 lg:w-5/6 md:pl-30 lg:pr-15',
    starRating: 'user-rating star-rating',
    primaryRadio: 'primary-radio',
    primaryLabel: 'primary-label  cursor-pointer',
    pgUrl: 'text-black underline',
    serverErrorText:
      'text-red text-13 font-sans-roma py-10 float-left w-2/3 px-25 border-r border-black text-center',
    serverErrorCount: 'text-red text-13 font-sans-roma py-10 float-left pl-30',
    errorText:
      'text-red text-sm font-HelveticaNeueLight pt-5 float-left w-full',
    pageError:
      'text-red text-sm font-HelveticaNeueLight py-10 md:pb-20 float-left w-full',
    hyphenRating: 'user-rating hyphen-rating',
    secondaryRadio: 'secondary-radio',
    recommendContainer: 'mb-20 sm:mb-30',
    BoldError: 'font-sans-bold text-s13-m15-l15',
    recommendLabelContainer:
      'sm:w-full md:w-full lg:w-full md:pl-0 lg:pl-0 md:text-left md:px-0',
    recommendLabel:
      'text-16 font-HelveticaNeueLight leading-24 sm:pb-10 md:pb-0 inline-block',
    recommendradioContain: 'pg-radio sm:w-full lg:w-full md:py-20 pb-10',
    recommendedRadio: 'recommended-radio',
    recommendlabelClass: 'primary-label font-sans-roma text-base',
    reviewWrapper: 'review-wrapper',
    inputSections:
      'sm:mb-33 md:pl-0 md:mb-33 floating-label sm:w-full md:w-1/2 md:pr-10p ',
    inputLabelContain: 'md:pl-15 lg:pl-0 sm:pb-10 md:pb-0',
    textboxContain: 'pb-15 flaot-left w-full',
    inputBox: 'w-full text-16 text-HelveticaNeueLight floating-input',
    labelHintText:
      'font-HelveticaNeueLight text-xs inline-block mt-1 text-grey leading-16',
    textArea:
      'border border-grey-light w-full p-1 rounded leading-normal floating-input floating-textarea',
    informationWrapper: 'information-wrapper w-full float-left',
    monthWrapper: 'block w-1/3  float-left',
    selectStyle: 'w-full text-16 text-HelveticaNeueLight floating-input',
    yearWrapper: 'block  w-1/3 float-left ml-15',
    termsWrapper: 'pb-20',
    checkboxWrapper: 'my-30',
    termsStyle:
      'mt-20 mb-10 inline-block text-16 leading-20 font-HelveticaNeueLight termsAndConditions',
    termsCheckbox: 'mr-10',
    termsLink: 'text-black no-underline text-16',
    trustContent:
      'text-16 leading-20 font-HelveticaNeueLight mb-20 Termsandcondtions',
    privacyClick:
      'text-lightorange text-16 font-HelveticaNeueMedium no-underline md:py-39',
    buttonWrapper:
      'w-full flex overflow-hidden items-center mb-20 text-center md:text-left flex-col-reverse',
    previewButton:
      'md:w-2/6 btn btn-solid text-center text-sm  md:mt-40 rounded-none font-BebasNeueRegular md:text-20 py-12 px-20 tracking-wider',
    termsLinkWrap:
      'md:flex text-center md:text-left text-base sm:py-20 md:py-0 md:w-full sm:text-left sm:leading-24',
    termsFirstLink: 'inline-block md:w-auto  sm:pr-2 md:pr-15 text-left',
    textBlack: 'text-lightorange text-16 font-HelveticaNeueMedium no-underline',
    termsSecondLink: 'inline-block md:w-1/2 border-black sm:pl-2 md:pl-15',
    dialogContentWrapper: 'text-sm font-sans-roma leading-s19-m19-l23',
    dialogTextContains: 'md:flex border-b',
    previewleft: 'md:w-1/3',
    marginbten: 'mb-10 text-16 font-HelveticaNeueBold',
    previewRating: 'mb-10',
    secRating: 'overflow-hidden',
    secondaryValue: 'secondary-rating value-rating',
    secondaryQuality: 'secondary-rating value-rating',
    previewRight: 'md:w-2/3 md:pl-15',
    flex: 'flex',
    widthHalf: 'w-1/2 text-base leading-normal text-black-lighter',
    reviewSummary: 'w-full my-20 text-16 font-HelveticaNeueMedium',
    reviewContent: 'w-full mb-20 text-break text-16 leading-24',
    previewButtonWrap: 'pt-30',
    editButton: 'btn btn-solid mr-25 md:text-20',
    submitButton: 'btn btn-solid md:text-20',
  },
};
